import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Stack, styled, Box, Typography, useTheme, Button } from "@mui/material";
import Select, { StylesConfig }  from "react-select";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme.js";
import urls from '../../constants/urls.js';
//import { schoolsData } from "../../data/mockData.js";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header.jsx";
//import { Button } from "antd";
//import urls from './../../../constants/urls';
import HeaderTwo from "../../components/HeaderTwo.jsx";



const TXTRoundedDiv= styled("div")(({theme})=>({
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #6BD5C0",
  //border: "#65BDC0",
  width: "100%",
  //height: "100%",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "10px",

}));



const StyledBox= styled(Box)({
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "1px",
});


const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "90%",
  marginTop: "1px",
  marginBottom: "1px"

});
 


export default function TransferStudents({ sendDataToParent, schoolIdGlobal }) {
 
  
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const [errors, setErrors]=useState({});
  

  const [changeToLoad, setChangeToLoad ]=useState(false);
  
  const [subClasses, setSubClasses]=useState([]);
  const [academicYears, setAcademicYears]=useState([]);

  const [subClassesNew, setSubClassesNew]=useState([]);
  const [academicYearsNew, setAcademicYearsNew]=useState([]);
  

  const [subClassNew, setSubClassNew]=useState(0);
  const [academicYearNew, setAcademicYearNew]=useState(0);

  const [academicYear, setAcademicYear]=useState(0);
  const [subClass, setSubClass]=useState(0);
    
  
  const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
  const[rootAPIURL, setRootAPIURL]=useState('');

  const[studentsData, setStudentsData]=useState([]);
  const[studentsDataOG, setStudentsDataOG]=useState([]);

  const[formDataSchool, setFormDataSchool]=useState({});
  
  //                     student_id, first_name, middle_name, last_name, full_name, gender, first_parent_name, first_mobile_number, student_status, school_status, second_parent_name, second_mobile_number, date_of_birth, school_name,
  const openUpdateSchool=(student_id, first_name, middle_name, last_name, full_name, gender, first_parent_name, first_mobile_number, student_status, school_status, second_parent_name, second_mobile_number, date_of_birth, school_name)=>{
    console.log("school id=" + student_id)
    //console.log("user email=" + user_email)
    sendDataToParent(student_id, first_name, middle_name, last_name, full_name, gender, first_parent_name, first_mobile_number, student_status, school_status, second_parent_name, second_mobile_number, date_of_birth, school_name);
        
  }

  
  
   
  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
    return {
    ...base,
    backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
    };
}
};

const searchStudents=(data)=>{
  
  let text=[]

  if(data==="" || data==""){
   
    setStudentsData(studentsDataOG)
  }
  else{
 
    text=studentsDataOG.filter(
    studentsDataOG=> 
      studentsDataOG.full_name.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.first_name.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.middle_name.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.last_name.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.first_mobile_number.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.second_mobile_number.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.first_parent_name.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.second_parent_name.toLowerCase().includes(data.toLowerCase()) || 
      studentsDataOG.date_of_birth.toLowerCase().includes(data.toLowerCase())
      //first_mobile_number date_of_birth
  )

  setStudentsData(text)

  }

}

const handleChangeInput = (e) =>{
  const {name, value } =e.target
  
  //
  searchStudents(value)
  //
  //setErrors({});
}

const handleChangeSelect = (e) =>{
  const {name, value } = e
  
  //console.log("e.target.name=" + e.target.name) handleChangeSelect
  console.log("name=" + name +  ", value=" + value)
  
  
  if(name==="sub_class"){
     setSubClass(e.id)
      //
     setChangeToLoad(!changeToLoad)
 }

 if(name==="academic_year"){
   setAcademicYear(e.id)
    // 
    setChangeToLoad(!changeToLoad)
  }

  if(name==="sub_class_new"){
    alert("sub class new id=" + e.id)
    setSubClassNew(e.id)
     //
    //setChangeToLoad(!changeToLoad)
}

if(name==="academic_year_new"){
    alert("academic year new id=" + e.id)
    setAcademicYearNew(e.id)
   // 
   //setChangeToLoad(!changeToLoad)
 }

 setErrors({});
  
}
  
  const columns = [
    { 
      field: "id", 
      headerName: "SNo",
      flex: 0.5, 
    },
    { 
      field: "full_name", 
      headerName: "Full name",
      flex: 1.5, 
    },
    
    {
      field: "gender",
      headerName: "Gender",
      flex: 0.5,
      cellClassName: "name-column--cell",
    },
   
    {
      field: "stream_name",
      headerName: "Stream",
      type: "string",
      headerAlign: "left",
      align: "left",
      flex: 1, 
    },
    {
      field: "academic_year",
      headerName: "Academic year",
      flex: 1,
    },
    {
      field: "first_mobile_number",
      headerName: "1st Parent's Mobile No",
      flex: 1,
    },

    {
      field: "second_mobile_number",
      headerName: "2nd Parent's Mobile No",
      flex: 1,
    },

    {
      field: "login_category_id",
      headerName: "Update",
      flex: 1,
      renderCell: ({ row: { student_id, first_name, middle_name, last_name, full_name, gender, first_parent_name, first_mobile_number, student_status, school_status, second_parent_name, second_mobile_number, date_of_birth, school_name } }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            //backgroundColor={}
            borderRadius="4px"
          >
            
            <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           //                             users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
           onClick={()=>openUpdateSchool( student_id, first_name, middle_name, last_name, full_name, gender, first_parent_name, first_mobile_number, student_status, school_status, second_parent_name, second_mobile_number, date_of_birth, school_name,)}
           >
                Update
            </Button>
          </Box>
        );
      },
    },
  ];
  

  const loadDataToTransferStudents=(data)=>{
    let iList=[]
    
    {
      data.map(function(dt, index){
          let ix=index+1
          iList.push(
            { 
              id: ix,
              student_id: dt.student_id,
              first_name: dt.first_name,
              middle_name: dt.middle_name,
              last_name: dt.last_name,
              full_name: dt.full_name,
              gender: dt.gender,
              
             
              date_of_birth: dt.date_of_birth,
              first_parent_name: dt.first_parent_name,
              first_mobile_number: dt.first_mobile_number,
              second_parent_name: dt.second_parent_name,
              second_mobile_number: dt.second_mobile_number,
              user_password: dt.user_password,
              login_category_id: dt.login_category_id,
              school_status: dt.school_status,
              school_id: dt.school_id,
              school_name: dt.school_name,
              student_status: dt.student_status,
              stream_name: dt.stream_name,
              academic_year: dt.academic_year
            })
            /***
              ***/
      })
    }

    setStudentsData(iList)
    setStudentsDataOG(iList)
  }


  //}

  useEffect(()=>{
    
    console.log(schoolIdGlobal + "," + subClass + "," + academicYear + "," )
    //let APIURL= APIROOTURL + "AllStudentsWithSubClassesViewEXT/" + schoolId
    let APIURL= APIROOTURL + "SubClassStudentsUsingSubClassAndAcademicYearViewEXT/" + schoolIdGlobal + "/" + subClass + "/" + academicYear
    let headerOptions={
        method: 'GET',
       
    } 
    //const [changeToLoad, setChangeToLoad ]=useState(false)
    console.log(" QWE132 url APIURL =" + APIURL);

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json=> {
        //
        loadDataToTransferStudents(json)
        //
        console.log(" QWE132data[0].name=" + json[0].first_name);
    })
    .finally((json) =>{ 
       // console.log("data01=" + json[0].name);
    })
    .catch( (error)=> console.log("QWE132 fetch school data error=" + error))


  }, [changeToLoad])

  
  
  
  const loadSubClasses=(data)=>{
    
    let newList=[]
    let newListNew=[]

    newList.push({ id: 0, label: 'Select stream', value: 'Select stream', name: 'sub_class'})

    newListNew.push({ id: 0, label: 'Select new stream', value: 'Select new stream', name: 'sub_class_new'})
    
    {
        data.map(function(dt){

          newList.push({id: dt.sub_class_id, label: dt.subclass_name, value: dt.subclass_name , name: 'sub_class'})
          
          newListNew.push({id: dt.sub_class_id, label: dt.subclass_name, value: dt.subclass_name , name: 'sub_class_new'})
        
        
        })
    }

    setSubClasses(newList)
    setSubClassesNew(newListNew)
  }
  

  
  useEffect(()=>{
    //alert(schoolIdGlobal + "," + usersId)
  let APIURL= APIROOTURL + "SingleSchoolSubClassViewEXT/" + schoolIdGlobal
  let headerOptions={
      method: 'GET',
  }
  
  fetch(APIURL, headerOptions)
  .then( response => response.json())
  .then( json =>{
   console.log("json 123 =" + json);
   console.log("json 5123 =" + json[0]['name']);
   console.log("json 123 =" + json[0].name);
   loadSubClasses(json)

  })
  .catch(error=> console.log("error=" + error))
  
  },[])

  

  const loadAcademicYears=(data)=>{
    let newList=[]
    let newListNew=[]
    
    newList.push({ id: 0, label: 'Select academic year', value: 'Select academic year', name: 'academic_year'})
    
    newListNew.push({ id: 0, label: 'Select new academic year', value: 'Select new academic year', name: 'academic_year_new'})
   
    {
        data.map(function(dt){
          
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'academic_year'})

          newListNew.push({id: dt.id, label: dt.name, value: dt.name , name: 'academic_year_new'})
          
          console.log("dt.name=" + dt.name)
        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setAcademicYears(newList)
    setAcademicYearsNew(newListNew)
  }
  

  
  
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "AcademicYearViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadAcademicYears(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])

    

         
const validateForm = (data) =>{
    const errors={};
    
    /***
          school_student: 0,
          exams_subject: 0,
          exams: 0,
          score: 0,
          status: 'Active',
    ***/
    if(data.academic_year==="0" || data.academic_year=="0" || data.academic_year===0 || data.academic_year==0){
           // console.log("if " + ", class name, data.student=" + data.exams_subject)
            errors.academic_year='Please select current academic year';
    }

    if(data.id==="" || data.id=="" || data.id===0 || data.id==0){
      // console.log("if " + ", class name, data.student=" + data.exams_subject)
       errors.academic_year_new='Please select new academic year';
       //alert("Please enter exam score")
    }

    //console.log("01 " + ", data.student=" + data.exams_subject)
    //sub_class
    if(data.school_sub_class==="0" || data.school_sub_class=="0" || data.school_sub_class===0 || data.school_sub_class==0){
       // console.log("if " + ", class name, data.student=" + data.exams_subject)
        errors.sub_class='Please select current stream';
    }
    //console.log("01 " + ", data.acade=" + data.student) academic_year
    if(data.student==="0" || data.student=="0" || data.student===0 || data.student==0){
       // console.log("if " + ", class name, data.school_student=" + data.school_student)
        errors.sub_class_new='Please select new stream';
    }
      
    return errors;
  }
  

  
    const TransferStudents=()=>{
        
       
        let formData={
          id: academicYearNew,
          student: subClassNew,
          school_sub_class: subClass,
          academic_year: academicYear,
          status: schoolIdGlobal,
        }

       // let newErrors=validateForm(formDataSchoolClassEXT);
       let newErrors=validateForm(formData);
        setErrors(newErrors);
        ///school_student
        console.log("errors.lenght=" + Object.keys(newErrors).length)
        if(Object.keys(newErrors).length===0){
          console.log("len0")
          TransferStudentsFn(formData)
        }
        else{
          console.log("len1")
        }
    
     
   }
  
  
    
   const TransferStudentsFn=(formData)=>{
     
    //CreateStudentExamScore
   //let url = API_URL;      CreateStudentExamScoreViewEXT   CreateStudentInAStreamViewEXT
   let APIURL= APIROOTURL + "CopyStudentsToAnotherStreamViewEXT"
   let picsId=0;
   axios
     .post(APIURL, formData, {
       headers: {
         "Content-type": "multipart/form-data",
       },
     })
     .then((res) => {
       console.log("res.data.msg=" + res.data.msg)
      
                       //School Student was successfully created
      if (res.data.msg==="Students were successfully copied to another stream"){
       //
       alert("Students were successfully copied to another stream")
      //  
      }
      else if (res.data.msg==="A user with similar mobile numbers has already been created"){
       //
       alert("A user with similar mobile numbers has already been created")
      //  
      }
      else{
       alert("Creating School class failed");
      }
      //
      
     // setload
     setChangeToLoad(!changeToLoad)
     })
     .finally(() => {
      
   
     })
     .catch((err) => console.log(err));

  }   


  return (
    <Box m="1px">
          
     {/***<HeaderTwo title="STUDENTS" subtitle="Students" /> ***/}
      
     

    <Stack direction="row" spacing={1} justifyContent="space-between">

      <StyledBox flex={3}>
      
       
      </StyledBox>
      
      <StyledBox flex={6}>  
          
          <br />

          <HeaderTwo title="TRANSFER SCHOOL STUDENTS" subtitle="Transfer School Students" />
      
          <TXTRoundedDiv>
          <Select
              name="sub_class"
              placeholder="Select current stream"
              options={subClasses}
              styles={customStyles}
              onChange={handleChangeSelect}
          />
          {errors.sub_class && (<span> {errors.sub_class} </span>)}
          </TXTRoundedDiv>

          <TXTRoundedDiv>
          <Select
              name="academic_year"
              placeholder="Select current academic year"
              options={academicYears}
              styles={customStyles}
              onChange={handleChangeSelect}
          />

          {errors.academic_year && (<span> {errors.academic_year} </span>)}
      </TXTRoundedDiv>
      

      <TXTRoundedDiv>
          <Select
              name="sub_class_new"
              placeholder="Select new stream"
              options={subClassesNew}
              styles={customStyles}
              onChange={handleChangeSelect}
          />
          {errors.sub_class_new && (<span> {errors.sub_class_new} </span>)}
          </TXTRoundedDiv>

          <TXTRoundedDiv>
          <Select
              name="academic_year_new"
              placeholder="Select new academic year"
              options={academicYearsNew}
              styles={customStyles}
              onChange={handleChangeSelect}
          />

          {errors.academic_year_new && (<span> {errors.academic_year_new} </span>)}
      </TXTRoundedDiv>
      
      <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           //                             users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
           onClick={()=>TransferStudents()}
           >
                TRANSFER
            </Button>
      
      {/***
      <TXTRoundedDiv>
           <StyledInput
            name="search_student"
            placeholder="Search student"
            onChange={handleChangeInput}
           />
      </TXTRoundedDiv>
       ***/}

      </StyledBox>
          
          <StyledBox flex={3}>

          </StyledBox>

        </Stack>

       <br />

      <Stack direction="row" spacing={1} justifyContent="space-between">

      <StyledBox flex={0.25}></StyledBox>

        <StyledBox flex={11.5}>
          
        <div>
        <DataGrid checkboxSelection rows={studentsData} columns={columns} />
        </div>

        </StyledBox>

         <StyledBox flex={0.25}></StyledBox>
         </Stack> 

    </Box>
  );

}
